const iniPrecision = 3

function GetAnswerString(value, unitsStr) {
  var answerStr = "N/A";
  return 1e12 > value && (answerStr = value.toPrecision(iniPrecision).toString() + " " + unitsStr), answerStr
}

export function showSummaryCheck(anchorProblem) {
  let success = anchorProblem.interactionX < 1 && anchorProblem.interactionY < 1
  success ? (

    document.getElementsByClassName('current-design-status')[0].innerHTML = 'Design OK',
    document.getElementsByClassName('current-design-status')[1].innerHTML = 'Design OK',
    document.getElementById("design-summary-panel").classList.remove("card-danger"),
    document.getElementById("design-summary-panel").classList.add("card-success"),
    document.getElementById("top-design-summary-card").classList.remove("card-danger"),
    document.getElementById("top-design-summary-card").classList.add("card-success")
    //str += '<span><i class="glyphicon glyphicon-ok text-success"></i> Tensile Capacity</span>'
  ) : (
    document.getElementsByClassName('current-design-status')[0].innerHTML = '<i class="fa fa-close text-danger"></i> Failed',
    document.getElementsByClassName('current-design-status')[1].innerHTML = '<i class="fa fa-close glyphicon-remove text-danger"></i> Failed',
    document.getElementById("design-summary-panel").classList.add("card-danger"),
    document.getElementById("design-summary-panel").classList.remove("card-success"),
    document.getElementById("top-design-summary-card").classList.add("card-danger"),
    document.getElementById("top-design-summary-card").classList.remove("card-success")
    //str += '<span><i class="glyphicon glyphicon-remove text-danger"></i> Tensile Capacity</span>'
  )
  // id="x-interaction"
  document.getElementById("x-interaction").innerHTML = `X Interaction = ${anchorProblem.interactionX.toPrecision(2).toString()}`
  document.getElementById("y-interaction").innerHTML = `Y Interaction = ${anchorProblem.interactionY.toPrecision(2).toString()}`
}
export function showTensionCheckSummary(anchorProblem) {
  var success = anchorProblem.interactionX < 1 && anchorProblem.interactionY < 1,
    str = '<span class="center-block text-center">';
  success ? (
    document.getElementById("tension-design-panel").classList.remove("card-danger"), 
    document.getElementById("tension-design-panel").classList.add("card-success"), 
    str += '<span><i class="glyphicon glyphicon-ok text-success"></i> Tensile Capacity</span>'
  ) : (
    document.getElementById("tension-design-panel").classList.add("card-danger"), 
    document.getElementById("tension-design-panel").classList.remove("card-success"), 
    str += '<span><i class="glyphicon glyphicon-remove text-danger"></i> Tensile Capacity</span>'
  ),
    str += "</span>",
    document.getElementById("tension-design-heading").innerHTML = str,
    str = '<span class="center-block text-center">',
    str += "<div><h4>&phi;N<sub>n</sub> = " + anchorProblem.maxTension.toPrecision(3) + " kips</h4></div>",
    str += "<div><h4><em>" + anchorProblem.tensionCapacityMessage + "</em></h4></div>",
    str += "</span>", document.getElementById("tension-design-body").innerHTML = str
}

export function showShearXSummary(anchorProblem) {
  var success = anchorProblem.interactionX < 1,
    str = '<span class="center-block text-center">';
  success ? (
    document.getElementById("shear-x-design-panel").classList.remove("card-danger"), 
    document.getElementById("shear-x-design-panel").classList.add("card-success"), 
    str += '<span><i class="glyphicon glyphicon-ok text-success"></i> Shear X Capacity</span>'
  ) : (
    document.getElementById("shear-x-design-panel").classList.add("card-danger"), 
    document.getElementById("shear-x-design-panel").classList.remove("card-success"), 
    str += '<span><i class="glyphicon glyphicon-remove text-danger"></i> Shear X Capacity</span>'
  ),
    document.getElementById("shear-x-design-heading").innerHTML = str

  str = '<span class="center-block text-center">',
    str += "<div><h4>&phi;V<sub>nx</sub> = " + anchorProblem.maxShearX.toPrecision(3) + " kips</h4></div>",
    str += "<div><h4><em>" + anchorProblem.shearXCapacityMessage + "</em></h4></div>",
    str += "</span>", document.getElementById("shear-x-design-body").innerHTML = str
}

export function showShearYSummary(anchorProblem) {
  var success = anchorProblem.interactionY < 1,
    str = '<span class="center-block text-center">';
  success ? (
    document.getElementById("shear-y-design-panel").classList.remove("card-danger"), 
    document.getElementById("shear-y-design-panel").classList.add("card-success"), 
    str += '<span><i class="glyphicon glyphicon-ok text-success"></i> Shear Y Capacity</span>'
  ) : (
    document.getElementById("shear-y-design-panel").classList.add("card-danger"), 
    document.getElementById("shear-y-design-panel").classList.remove("card-success"), 
    str += '<span><i class="glyphicon glyphicon-remove text-danger"></i> Shear Y Capacity</span>'
  ),
    document.getElementById("shear-y-design-heading").innerHTML = str
  str = '<span class="center-block text-center">',
    str += "<div><h4>&phi;V<sub>ny</sub> = " + anchorProblem.maxShearY.toPrecision(3) + " kips</h4></div>",
    str += "<div><h4><em>" + anchorProblem.shearYCapacityMessage + "</em></h4></div>",
    str += "</span>", document.getElementById("shear-y-design-body").innerHTML = str
}

export function showInteractionCalcs(anchorProblem, oLoad) {
  let xInteraction = anchorProblem.interactionX.toPrecision(2).toString()
  let yInteraction = anchorProblem.interactionY.toPrecision(2).toString()

  document.getElementById('x-interaction-calc-value').innerHTML = xInteraction
  document.getElementById('y-interaction-calc-value').innerHTML = yInteraction

  let str = `N<sub>xua</sub> = ${GetAnswerString(oLoad.nZ, "kips")},`
  str += ` &phi;N<sub>xn</sub> = ${GetAnswerString(anchorProblem.maxTension, "kips")}, <br>`
  str += ` V<sub>xua</sub> = ${GetAnswerString(oLoad.vX, "kips")},` 
  str += ` &phi;V<sub>xn</sub> = ${GetAnswerString(anchorProblem.maxShearX, "kips")}`
  document.getElementById('x-interaction-calc-values').innerHTML = str

  str = `N<sub>ua</sub> = ${GetAnswerString(oLoad.nZ, "kips")},`
  str += ` &phi;N<sub>yn</sub> = ${GetAnswerString(anchorProblem.maxTension, "kips")}, <br>`
  str += ` V<sub>yua</sub> = ${GetAnswerString(oLoad.vY, "kips")},` 
  str += ` &phi;V<sub>yn</sub> = ${GetAnswerString(anchorProblem.maxShearY, "kips")}`
  document.getElementById('y-interaction-calc-values').innerHTML = str

}
export function showTensionCapacityCalcs(oAnchorProblem, oBolt, oGeometry) {
  let htmlStr = "<table>"
  htmlStr += "<tr><th align='left'>Bolt Tension (D.5.1) = " + GetAnswerString(oAnchorProblem.phiNsa, "kips") + "</td></th>",
    htmlStr += "<tr><td>&phi; N<sub>sa</sub> = &phi; n A<sub>se</sub>  f<sub>uta</sub></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiTensionSteel + ", ",
    htmlStr += "n = " + oGeometry.NumberOfBolts() + ", ",
    htmlStr += "A<sub>se</sub> = " + oBolt.GetArea() + " in<sup>2</sup></td></tr>",
    htmlStr += "<tr><td>f<sub>uta</sub> = " + oBolt.tensileStrength + " ksi</td></tr>",
    htmlStr += "</table>",
    document.getElementById("bolt-tension-calcs-body").innerHTML = htmlStr

  htmlStr = "<table>",
    htmlStr += "<tr><th align='left'>Concrete Breakout (D.5.2) = " + GetAnswerString(oAnchorProblem.ncb, "kips") + "</td></th>",
    htmlStr += "<tr><td>&phi; N<span class='ws-subscript'>cb</span> = &phi;  A<span class='ws-subscript'>nc</span>/",
    htmlStr += "A<span class='ws-subscript'>nco</span>  &psi;<span class='ws-subscript'>ec</span> ",
    htmlStr += "&psi;<span class='ws-subscript'>ed</span>  &psi;<span class='ws-subscript'>c</span> ",
    htmlStr += "&psi;<span class='ws-subscript'>cp</span>  N<span class='ws-subscript'>b</span>",
    htmlStr += "</td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiTensionConcreteBreakOut + ", ",
    htmlStr += "A<span class='ws-subscript'>nc</span> = " + oAnchorProblem.Anc.toPrecision(iniPrecision) + " in<sup>2</sup>, ",
    htmlStr += "A<span class='ws-subscript'>nco</span> = " + oAnchorProblem.Anco.toPrecision(iniPrecision) + " in<sup>2</sup></td></tr>",
    htmlStr += "<tr><td>&psi;<span class='ws-subscript'>ec</span> = 1.0, ",
    htmlStr += "&psi;<span class='ws-subscript'>ed</span> = " + oAnchorProblem.PsiedN.toPrecision(iniPrecision) + ", ",
    htmlStr += "&psi;<span class='ws-subscript'>c</span> = 1.0</td></tr>",
    htmlStr += "<tr><td>&psi;<span class='ws-subscript'>cp</span> = 1.0, ",
    htmlStr += "N<span class='ws-subscript'>b</span> = " + oAnchorProblem.Nb.toPrecision(iniPrecision) + " kips, ",
    htmlStr += "h<span class='ws-subscript'>ef</span> = " + oAnchorProblem.Hef_ConcBreakout.toPrecision(iniPrecision) + " in, ",
    htmlStr += "k<span class='ws-subscript'>c</span> = " + oAnchorProblem.kc + "</td></tr>",
    htmlStr += "</table>",
    document.getElementById("breakout-calcs-body").innerHTML = htmlStr

  htmlStr = "<table>",
    htmlStr += "<tr><th align='left'>Pullout (D.5.3) = " + GetAnswerString(oAnchorProblem.Npn, "kips") + "</td></th>",
    htmlStr += "<tr><td>&phi; N<span class='ws-subscript'>pn</span> = &phi;  &psi;<span class='ws-subscript'>c</span>  N<span class='ws-subscript'>p</span></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiPullout + ", ",
    htmlStr += "&psi;<span class='ws-subscript'>c</span> = 1.0, ",
    htmlStr += "N<span class='ws-subscript'>p</span> = " + oAnchorProblem.Np.toPrecision(3) + " kips</td></tr>",
    htmlStr += oBolt.IsAnchorHooked() ? "<tr><td>e<span class='ws-subscript'>n</span> = " + oBolt.hookLength.toPrecision(3) + "` in</td></tr>" : "<tr><td>A<span class='ws-subscript'>brg</span> = " + oBolt.GetBearingArea() + " in<span class='ws-superscript'>2</span></td></tr>",
    htmlStr += "</table>",
    document.getElementById("pullout-calcs-body").innerHTML = htmlStr

  htmlStr = "<table>",
    htmlStr += "<tr><th align='left'>Side-Face Blowout (D.5.4) = " + GetAnswerString(oAnchorProblem.Nsb, "kips") + "</td></th>",
    htmlStr += "<tr><td>&phi;N<span class='ws-subscript'>sb</span> = &phi; (1+s/(6 ca<span class='ws-subscript'>1</span> ) ) 160  ca<span class='ws-subscript'>1</span>  &radic;<span style='text-decoration:overline;'>&nbsp;A<span class='ws-subscript'>rg</span> f'c</span></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiSideFace + ", ",
    htmlStr += "ca<span class='ws-subscript'>1</span> = " + oAnchorProblem.Ca1SideFace.toPrecision(3) + "</td></tr>",
    htmlStr += "</table>",
    document.getElementById("blowout-calcs-body").innerHTML = htmlStr
}

export function showShearCalcs(oAnchorProblem, oBolt, oGeometry) {
  let htmlStr = "<table>"
  htmlStr += "<tr><th align='left'>Bolt Shear (D.6.1) = " + GetAnswerString(oAnchorProblem.vsaX, "kips") + "</th></tr>",
    htmlStr += "<tr><td>&phi;V<span class='ws-subscript'>sa</span> = &phi;  n  A<span class='ws-subscript'>se</span>  f<span class='ws-subscript'>uta</span></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiVxSteel + ", ",
    htmlStr += "n = " + oGeometry.NumberOfBolts() + ", ",
    htmlStr += "A<span class='ws-subscript'>se</span> = " + oBolt.GetArea() + " in<span class='ws-superscript'>2</span></td></tr>",
    htmlStr += "<tr><td>f<span class='ws-subscript'>uta</span> = " + oBolt.tensileStrength + " ksi",
    htmlStr += "</table>", 
    document.getElementById("bolt-shear-x-calcs-body").innerHTML = htmlStr

  htmlStr = "<table>",
    htmlStr += "<tr><th align='left'>Bolt Shear (D.6.1) = " + GetAnswerString(oAnchorProblem.vsaY, "kips") + "</th></tr>",
    htmlStr += "<tr><td>&phi;V<span class='ws-subscript'>sa</span> = &phi;  n  A<span class='ws-subscript'>se</span>  f<span class='ws-subscript'>uta</span></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiVxSteel + ", ",
    htmlStr += "n = " + oGeometry.NumberOfBolts() + ", ",
    htmlStr += "A<span class='ws-subscript'>se</span> = " + oBolt.GetArea() + " in<span class='ws-superscript'>2</span></td></tr>",
    htmlStr += "<tr><td>f<span class='ws-subscript'>uta</span> = " + oBolt.tensileStrength + " ksi",
    htmlStr += "</table>", 
    document.getElementById("bolt-shear-y-calcs-body").innerHTML = htmlStr
    
  htmlStr = "<table>",
    htmlStr += "<tr><th align='left'>Concrete Breakout (D.6.2) = " + GetAnswerString(oAnchorProblem.vcbX, "kips") + "</th></tr>",
    htmlStr += "<tr><td>&phi;V<span class='ws-subscript'>cb</span> = &phi;  A<span class='ws-subscript'>vc</span>/A<span class='ws-subscript'>vco</span>  &psi;<span class='ws-subscript'>ec</span>  &psi;<span class='ws-subscript'>ed</span>  &psi;<span class='ws-subscript'>c</span>  V<span class='ws-subscript'>b</span></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiShearXBreakout + ", ",
    htmlStr += "A<span class='ws-subscript'>vc</span> = " + oAnchorProblem.avcShearX.toPrecision(iniPrecision) + " in<span class='ws-superscript'>2</span>, ",
    htmlStr += "A<span class='ws-subscript'>vco</span> = " + oAnchorProblem.avcoShearX.toPrecision(iniPrecision) + " in<span class='ws-superscript'>2</span></td></tr>",
    htmlStr += "<tr><td>&psi;<span class='ws-subscript'>ec</span> = 1.0, ",
    htmlStr += "&psi;<span class='ws-subscript'>ed</span> = " + oAnchorProblem.psiEdvShearX.toPrecision(iniPrecision) + ", ",
    htmlStr += "&psi;<span class='ws-subscript'>c</span> = 1.0</td></tr>",
    htmlStr += "<tr><td>&psi;<span class='ws-subscript'>h</span> = 1.0, ",
    htmlStr += "V<span class='ws-subscript'>b</span> = " + oAnchorProblem.VbShearX.toPrecision(iniPrecision) + " kips, ",
    htmlStr += "ca<span class='ws-subscript'>1</span> = " + oAnchorProblem.ca1ShearX.toPrecision(iniPrecision) + " in</td></tr>",
    htmlStr += "</table>", 
    document.getElementById("breakout-x-calcs-body").innerHTML = htmlStr
  
  htmlStr = "<table>",
    htmlStr += "<tr><th align='left'>Concrete Breakout (D.6.2) = " + GetAnswerString(oAnchorProblem.vcbY, "kips") + "</th></tr>",
    htmlStr += "<tr><td>&phi;V<span class='ws-subscript'>cb</span> = &phi;  A<span class='ws-subscript'>vc</span>/A<span class='ws-subscript'>vco</span>  &psi;<span class='ws-subscript'>ec</span>  &psi;<span class='ws-subscript'>ed</span>  &psi;<span class='ws-subscript'>c</span>  V<span class='ws-subscript'>b</span></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiShearYBreakout + ", ",
    htmlStr += "A<span class='ws-subscript'>vc</span> = " + oAnchorProblem.avcShearY.toPrecision(iniPrecision) + " in<span class='ws-superscript'>2</span>, ",
    htmlStr += "A<span class='ws-subscript'>vco</span> = " + oAnchorProblem.avcoShearY.toPrecision(iniPrecision) + " in<span class='ws-superscript'>2</span></td></tr>",
    htmlStr += "<tr><td>&psi;<span class='ws-subscript'>ec</span> = 1.0, ",
    htmlStr += "&psi;<span class='ws-subscript'>ed</span> = " + oAnchorProblem.psiEdvShearY.toPrecision(iniPrecision) + ", ",
    htmlStr += "&psi;<span class='ws-subscript'>c</span> = 1.0</td></tr>",
    htmlStr += "<tr><td>&psi;<span class='ws-subscript'>h</span> = 1.0, ",
    htmlStr += "V<span class='ws-subscript'>b</span> = " + oAnchorProblem.VbShearY.toPrecision(iniPrecision) + " kips, ",
    htmlStr += "ca<span class='ws-subscript'>1</span> = " + oAnchorProblem.ca1ShearY.toPrecision(iniPrecision) + " in</td></tr>",
    htmlStr += "</table>", 
    document.getElementById("breakout-y-calcs-body").innerHTML = htmlStr
    
  htmlStr = "<table>",
    htmlStr += "<tr><th align='left'>Concrete Pryout (D.6.3) = " + GetAnswerString(oAnchorProblem.vcpX, "kips") + "</td></th>",
    htmlStr += "<tr><td>&phi;V<span class='ws-subscript'>cp</span> = &phi;  k<span class='ws-subscript'>cp</span>  N<span class='ws-subscript'>cb</span></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiPryoutShearX + ", ",
    htmlStr += "k<span class='ws-subscript'>cp</span> = " + oAnchorProblem.kcpShearX.toPrecision(iniPrecision),
    htmlStr += "</table>", 
    document.getElementById("pryout-x-calcs-body").innerHTML = htmlStr
    
  htmlStr = "<table>",
    htmlStr += "<tr><th align='left'>Concrete Pryout (D.6.3) = " + GetAnswerString(oAnchorProblem.vcpY, "kips") + "</td></th>",
    htmlStr += "<tr><td>&phi;V<span class='ws-subscript'>cp</span> = &phi;  k<span class='ws-subscript'>cp</span>  N<span class='ws-subscript'>cb</span></td></tr>",
    htmlStr += "<tr><td>&phi; = " + oAnchorProblem.phiPryoutShearY + ", ",
    htmlStr += "k<span class='ws-subscript'>cp</span> = " + oAnchorProblem.kcpShearY.toPrecision(iniPrecision),
    htmlStr += "</table>", 
    document.getElementById("pryout-y-calcs-body").innerHTML = htmlStr
}